import { I04DIMPUISSCHAUD_State } from '@batical/types/src'

const I04DIMPUISSCHAUD: I04DIMPUISSCHAUD_State = {
  in_nbJourChauffe: 190.0,
  bati_version: 3,
  name: '',
  deleted: 0,
  saveDate: 0,
  dju_uuid: '2F384721-09DE-4B82-8582-FD35735868A8',
  in_surfaceHabitat: 2000.0,
  in_hauteur_plafond: 2.55,
  coeffG_uuid: '1',
  in_tempExtBase: 0.0,
  in_tempConsigneAmbiance: 23.0,
  res_puissanceTotale: 0.0,
  calcul_code: 'I04DIMPUISSCHAUD',
  //version 2  -> 2.3.0
  in_nombreHeureReduit: 8,
  in_nombreDegreAbaisse: 6,
  res_intermittence: 0,
  res_deperdition: 0,
  res_consoAnnuelleEstime: 0,
  //version 3 =>  2.5.0 (migration store version 2)
  res_coeffG: 0.35,
  in_choixCalculG: 0,
  dataBar: [],
  mode: 'none'
}

export default I04DIMPUISSCHAUD
